import { render, staticRenderFns } from "./ManufacturingLogbookHistoricalPage.vue?vue&type=template&id=48fe4b07"
import script from "./ManufacturingLogbookHistoricalPage.vue?vue&type=script&lang=js"
export * from "./ManufacturingLogbookHistoricalPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports